import {UA} from '@colonist/mobile'

export class UIDeviceController {
    static isUserOnTabletApp() {
        if(window.location.hostname.includes('discordsays')) return false

        const userAgent = navigator.userAgent
        const tabletUserAgents = [UA.IPAD_APP_USER_AGENT, UA.TABLET_APP_USER_AGENT]
        return tabletUserAgents.includes(userAgent)
    }

    static isUserOnMobileApp(): boolean {
        if(window.location.hostname.includes('discordsays')) return false

        const userAgent = navigator.userAgent
        const mobileUserAgents = [UA.IPHONE_APP_USER_AGENT, UA.IPAD_APP_USER_AGENT, UA.TABLET_APP_USER_AGENT, UA.ANDROID_APP_USER_AGENT]
        return mobileUserAgents.includes(userAgent) || window.location.pathname.includes('/mobile')
    }

    static isUserOnIOSApp(): boolean {
        if(window.location.hostname.includes('discordsays')) return false

        const userAgent = navigator.userAgent
        const iosUserAgents = [UA.IPHONE_APP_USER_AGENT, UA.IPAD_APP_USER_AGENT]
        return iosUserAgents.includes(userAgent)
    }

    /**
     * @deprecated only works in the discord mount, find a better way
     */
    static isUserOnDiscordMobile() {
        if(!window.location.hostname.includes('discordsays')) return false

        const urlParams = new URLSearchParams(new URL(window.location.href).search)
        const platform = urlParams.get('platform')
        return platform == 'mobile'
    }

    static isUserOnSafariOrIOS(): boolean {
        const userAgent = navigator.userAgent.toLowerCase()
        const isIOS = /ipad|iphone|ipod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        const isSafari = userAgent.includes('safari') && !userAgent.includes('chrome')
        return isIOS || isSafari
    }
}
